export default "__VITE_ASSET__CAVw7PNc__"